import { Component, Inject, OnInit, inject, DestroyRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
export interface DialogData {
  type: 'systemHealth' | 'systemSecurity' | 'systemAvailability';
}

@Component({
    selector: 'app-metering-resources-dialog',
    templateUrl: './metering-resources-dialog.component.html',
    styleUrls: ['./metering-resources-dialog.component.scss'],
    standalone: false
})
export class MeteringResourcesDialogComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  systemHealthChartOptions: any;
  systemHealthData: any;
  systemSecurityChartOptions: any;
  serviceAvailableChartOptions: any;
  running: number;
  issue: number;
  down: number;
  dataObject: any;
  systemHealthResult: any;
  defaultSelection = 'down';
  toggle = this.defaultSelection;
  openDialog: any;
  systemSecurityData: any;
  systemSecurityResult: any;
  securityDefaultSelection = 'medium';
  securityToggle = this.securityDefaultSelection;

  systemAvailabilityData: any;
  systemAvailabilityResult: any;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: DialogData, public datepipe: DatePipe) {
  }

  ngOnInit(): void {
    this.openDialog = this.dialogData.type;
    const systemHealthStaticData = {
      running: [
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'Running' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'Running' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'Running' }
      ],
      issue: [
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'issue' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'issue' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'issue' }
      ],
      down: [
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'down' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'down' },
          { service: 'Test', lob: 'Retail Banking', time: '2022-07-11T09:03:31.198Z', status: 'down' }
      ]
    };

    this.systemSecurityData = {
      medium:[
        {subject:'Security breach',severity: 'Medium',ID: 'CVE-2022-22963',time:'2022-04-30T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Medium',ID: 'CVE-2022-18865',time:'2022-04-29T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Medium',ID: 'CVE-2022-12985',time:'2022-04-28T05:13:39.631Z'}
      ],
      low:[
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-22859',time:'2022-04-30T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-18468',time:'2022-04-29T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-11453',time:'2022-04-27T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-12354',time:'2022-04-26T05:13:39.631Z'}
      ],
      critical:[
        {subject:'Security breach',severity: 'Critical',ID: 'CVE-2022-12358',time:'2022-04-28T05:13:39.631Z'},
      ],
      high:[
        {subject:'Security breach',severity: 'High',ID: 'CVE-2022-13558',time:'2022-04-25T05:13:39.631Z'},
        {subject:'Security breach',severity: 'High',ID: 'CVE-2022-11356',time:'2022-04-25T05:13:39.631Z'}
      ],
      all: [
        {subject:'Security breach',severity: 'Medium',ID: 'CVE-2022-21589',time:'2022-04-30T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Medium',ID: 'CVE-2022-18987',time:'2022-04-29T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Medium',ID: 'CVE-2022-17698',time:'2022-04-28T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-21974',time:'2022-04-30T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-18485',time:'2022-04-29T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-17458',time:'2022-04-27T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Low',ID: 'CVE-2022-13589',time:'2022-04-26T05:13:39.631Z'},
        {subject:'Security breach',severity: 'Critical',ID: 'CVE-2022-17879',time:'2022-04-28T05:13:39.631Z'},
        {subject:'Security breach',severity: 'High',ID: 'CVE-2022-12458',time:'2022-04-25T05:13:39.631Z'},
        {subject:'Security breach',severity: 'High',ID: 'CVE-2022-12354',time:'2022-04-25T05:13:39.631Z'}
      ]
    };

    this.dataObject = systemHealthStaticData;
    this.systemHealth(systemHealthStaticData);
    this.systemSecurity();
    this.getSystemHealthData(this.defaultSelection);
    this.getSystemSecurityData(this.securityDefaultSelection);
    this.serviceAvailability();
  }

  getSystemHealthData(type): void {
    this.toggle = type;
    this.systemHealthResult = this.dataObject[type];
  }

  getSystemSecurityData(type): void {
    this.securityToggle = type;
    this.systemSecurityResult = this.systemSecurityData[type];
  }

  systemHealth(res): void {
    this.running = res.running.length;
    this.issue = res.issue.length;
    this.down = res.down.length;
    const count = this.running + this.issue + this.down;

    const date = this.datepipe.transform(new Date(), 'dd MMM 2022');
    this.systemHealthChartOptions = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        selectedMode: false,
        show: true,
        bottom: '2%',
        left: 'center',
        itemGap: 25,
        itemWidth: 16,
        itemHeight: 16,
        textStyle: {
        color: '#003E75',
        fontFamily: 'worksans',
        fontSize: 14
        }
      },
      series: [
        {
          name: 'System Health',
          type: 'pie',
          radius: ['53%', '65%'],
          top: -60,
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'center',
            formatter: [
              '{boldFont|'+`${count}`+'}',
              '{normalFont|No of Services \n '+`${date}`+'}',
            ].join('\n'),
            rich: {
              boldFont: {
                fontSize: '50',
                fontWeight: '600',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 60
              },
              normalFont: {
                padding: 40,
                fontSize: '14',
                fontWeight: '400',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 20
              }
            },
            fontSize: '20',
            emphasis: {
              show: true
            }
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '40',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          color: [
            '#C7C52A',
            '#B53B20',
            '#F08261'
          ],
          data: [
            { value: `${this.running}`, name: this.running + ' Running' },
            { value: `${this.issue}`, name: this.issue + ' Issues' },
            { value: `${this.down}`, name: this.down + ' Stopped' }
          ]
        }
      ]
    };
  }

  systemSecurity(): void {
    this.systemSecurityChartOptions = {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        selectedMode: false,
        show: true,
        bottom: '2%',
        left: 'center',
        itemGap: 25,
        itemWidth: 16,
        itemHeight: 16,
        textStyle: {
        color: '#003E75',
        fontFamily: 'worksans',
        fontSize: 14
        }
      },
      series: [
        {
          name: 'System Security',
          type: 'pie',
          radius: ['53%', '65%'],
          top: -50,
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'center',
            formatter: [
              '{boldFont|08}',
              '{normalFont|Security events in \n last 7 days}',
            ].join('\n'),
            rich: {
              boldFont: {
                fontSize: '50',
                fontWeight: '600',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 60
              },
              normalFont: {
                padding: 40,
                fontSize: '14',
                fontWeight: '400',
                color: '#293276',
                fontFamily: 'worksans',
                lineHeight: 20
              }
            },
            fontSize: '20',
            emphasis: {
              show: true
            }
          },
          emphasis: {
            label: {
              show: false,
              fontSize: '40',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          color: [
            '#B53B20',
            '#293276',
            '#C7C52A',
            '#C9D9F2'
          ],
          data: [
            { value: 1, name: '1 Critical' },
            { value: 2, name: '2 High' },
            { value: 3, name: '3 Medium' },
            { value: 2, name: '2 Low' }
          ]
        }
      ]
    };
  }

  serviceAvailability(): void {
    this.serviceAvailableChartOptions = {
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['5th', '6th', '7th', '8th', '9th', '10th', '11th'],
        axisLabel: {
          color: '#293276',
        },
        axisLine: {
          lineStyle: {
          color: '#D1D9E3'
          }
        }
      },
      yAxis: {
        type: 'value',
        min: 99.6,
        max: 100,
        axisLabel: {
          formatter: '{fontStyle|'+`{value} %`+'}',
          rich: {
            fontStyle: {
              color: '#293276'
            },
          }
        },
        splitLine: {
          lineStyle: {
            color: '#D1D9E3'
          }
        },
      },
      series: [
        {
          name: 'Availability',
          data: [99.91, 99.94, 99.98, 99.99, 100, 99.99, 100],
          type: 'line',
          areaStyle: {
            color: '#EAF2FF',
            opacity: 0.5,
          },
          lineStyle: {
            color: '#293276',
          },
          markLine: {
            data: [{ type: 'average', name: 'Avg' }],
            label: {
              show: false
            },
            symbol: 'none',
            lineStyle: {
              color: '#B53B20'
            },
          }
        }
      ]
    };
  }

}
